import React, { useEffect, useState } from "react";
import { useAuth } from "../context";

export default function useFetch(getFunction) {
  const { dispatch } = useAuth();

  const [data, setData] = useState(null);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    setStatus("pending");
    setData(null);
    setError(null);

    getFunction()
      .then((res) => {
        setData(res);
        setStatus("success");
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
        }
        setError(err);
        setStatus("error");
      });
  }, [getFunction]);

  return {
    data,
    error,
    isLoading: status === "pending",
    isSuccess: status === "success",
    isError: status === "error",
  };
}
